module.exports = __webpack_public_path__ + "static.ibuole.com/venue/build/img/member.17db6b5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/member.jpg
// module id = vkRp
// module chunks = 1